// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditVisitPopup-module__grid___rWG6H {
  display: grid;
  padding: 25px 30px;
  grid-row-gap: 25px;
  grid-column-gap: 25px;
  grid-template-columns: repeat(2, 1fr);
}
.EditVisitPopup-module__grid___rWG6H .EditVisitPopup-module__width100___azgXC {
  grid-column: 2 span;
}
.EditVisitPopup-module__grid___rWG6H .EditVisitPopup-module__input___lBWdw {
  width: 66%;
}
.EditVisitPopup-module__grid___rWG6H .EditVisitPopup-module__input___lBWdw .EditVisitPopup-module__option___aswyA {
  color: get-color(greenNew, dark);
}
.EditVisitPopup-module__grid___rWG6H .EditVisitPopup-module__select___NP0En {
  width: 66%;
}

.EditVisitPopup-module__buttonsContainer___Ki_O1 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}

.EditVisitPopup-module__sectionSeparator___CgL4h {
  grid-column: 2 span;
  border-top: 2px solid rgba(91, 91, 91, 0.35);
  margin: 12px 0 20px;
}

.EditVisitPopup-module__caregiverSection___Fcl7_ {
  grid-column: 2 span;
  padding: 12px 0 4px;
}

.EditVisitPopup-module__caregiverControlsRow___BEPR8 {
  margin-bottom: 12px;
}

.EditVisitPopup-module__caregiverCard___h9ZD_ {
  margin-top: 10px;
  padding: 12px;
}

.EditVisitPopup-module__caregiverTitle___u6Hnz {
  font-size: 16px;
  color: get-color(greenNew, dark) !important;
}

.EditVisitPopup-module__caregiverInfoText___qu6PO {
  color: get-color(greenNew, dark) !important;
}

.EditVisitPopup-module__caregiverName___ODMO2 {
  color: get-color(greenNew, dark) !important;
}

.EditVisitPopup-module__caregiverChip___F_zYf {
  background: rgba(91, 91, 91, 0.08);
  border-radius: 12px;
  padding: 2px 8px;
}

.EditVisitPopup-module__caregiverChipRemove___ulGQQ {
  border: none;
  background: transparent;
  color: get-color(greenNew, dark);
  cursor: pointer;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/popups/EditVisitPopup/EditVisitPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qCAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,UAAA;AAAJ;AAEI;EACE,gCAAA;AAAN;AAIE;EACE,UAAA;AAFJ;;AAMA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AAHF;;AAOA;EACE,mBAAA;EACA,4CAAA;EACA,mBAAA;AAJF;;AAQA;EACE,mBAAA;EACA,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,gBAAA;EACA,aAAA;AALF;;AASA;EACE,eAAA;EACA,2CAAA;AANF;;AAUA;EACE,2CAAA;AAPF;;AAWA;EACE,2CAAA;AARF;;AAYA;EACE,kCAAA;EACA,mBAAA;EACA,gBAAA;AATF;;AAYA;EACE,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;AATF","sourcesContent":[".grid {\n  display: grid;\n  padding: 25px 30px;\n  grid-row-gap: 25px;\n  grid-column-gap: 25px;\n  grid-template-columns: repeat(2, 1fr);\n\n  .width100 {\n    grid-column: 2 span;\n  }\n\n  .input {\n    width: 66%;\n\n    .option {\n      color: get-color(greenNew, dark);\n    }\n  }\n\n  .select {\n    width: 66%;\n  }\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n\n// Full-width subtle divider to visually separate sections inside the popup\n.sectionSeparator {\n  grid-column: 2 span;\n  border-top: 2px solid rgba(91, 91, 91, 0.35);\n  margin: 12px 0 20px;\n}\n\n// Caregiver section spacing\n.caregiverSection {\n  grid-column: 2 span;\n  padding: 12px 0 4px;\n}\n\n.caregiverControlsRow {\n  margin-bottom: 12px;\n}\n\n.caregiverCard {\n  margin-top: 10px;\n  padding: 12px;\n}\n\n// Title for caregiver attendees section\n.caregiverTitle {\n  font-size: 16px;\n  color: get-color(greenNew, dark) !important;\n}\n\n// Info text under caregiver select (Attached/Selected labels)\n.caregiverInfoText {\n  color: get-color(greenNew, dark) !important;\n}\n\n// Caregiver name inside the card\n.caregiverName {\n  color: get-color(greenNew, dark) !important;\n}\n\n// Simple chip styling for caregiver labels under the select\n.caregiverChip {\n  background: rgba(91, 91, 91, 0.08);\n  border-radius: 12px;\n  padding: 2px 8px;\n}\n\n.caregiverChipRemove {\n  border: none;\n  background: transparent;\n  color: get-color(greenNew, dark);\n  cursor: pointer;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `EditVisitPopup-module__grid___rWG6H`,
	"width100": `EditVisitPopup-module__width100___azgXC`,
	"input": `EditVisitPopup-module__input___lBWdw`,
	"option": `EditVisitPopup-module__option___aswyA`,
	"select": `EditVisitPopup-module__select___NP0En`,
	"buttonsContainer": `EditVisitPopup-module__buttonsContainer___Ki_O1`,
	"sectionSeparator": `EditVisitPopup-module__sectionSeparator___CgL4h`,
	"caregiverSection": `EditVisitPopup-module__caregiverSection___Fcl7_`,
	"caregiverControlsRow": `EditVisitPopup-module__caregiverControlsRow___BEPR8`,
	"caregiverCard": `EditVisitPopup-module__caregiverCard___h9ZD_`,
	"caregiverTitle": `EditVisitPopup-module__caregiverTitle___u6Hnz`,
	"caregiverInfoText": `EditVisitPopup-module__caregiverInfoText___qu6PO`,
	"caregiverName": `EditVisitPopup-module__caregiverName___ODMO2`,
	"caregiverChip": `EditVisitPopup-module__caregiverChip___F_zYf`,
	"caregiverChipRemove": `EditVisitPopup-module__caregiverChipRemove___ulGQQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
